module.exports = __webpack_public_path__ + "static/media/sf-test-7.f919c2d1.mp3";